import i18n from "i18next";
import { ColumnsType } from "antd/lib/table/interface";
import { CurrencyHelper } from "@/utils/helpers/currency-helper";

const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const columns = (
  isCurrency: boolean,
): ColumnsType<{
  key: string;
  title: string;
  stats: number[];
}> => [
  {
    title: "",
    dataIndex: "title",
    className: "table-title",
  },
  ...months.map((month) => ({
    title: i18n.t(`offices.balanceAndStatistics.headers.month${month}`),
    dataIndex: "stats",
    className: "text-center",
    render: (stats: number[]) => {
      return `${
        isCurrency
          ? CurrencyHelper.formatCurrency(stats[month - 1])
          : stats[month - 1]
      }`;
    },
  })),
  {
    title: i18n.t("offices.balanceAndStatistics.headers.total"),
    dataIndex: "stats",
    className: "text-center",
    render: (stats: number[]) => {
      return stats.reduce((total, stat) => total + stat, 0);
    },
  },
];
